export default __webpack_public_path__ + "./image/1c4c109e0abb3e7ab6c4ae83cfece42f.png";